import Immutable from 'immutable';
import { SET_COHORT_SCHEDULE } from './actions';
import { SET_MODULE_PROGRESS_FOR_COURSE } from '../ModuleProgress/actions';

const DEFAULT_STATE = Immutable.fromJS({
  /*
  cohortPath: {
    moduleStartdates,
    schedule,
    schedulingList
  }
  */
});

/**
 * @param {object} state
 * @param {object} action
 * @returns {object}
 */
export function CohortSchedules(state = DEFAULT_STATE, action) {
  switch (action.type) {
    case SET_MODULE_PROGRESS_FOR_COURSE:
    case SET_COHORT_SCHEDULE: {
      const { cohortPath, schedule } = action;
      return state.set(cohortPath, Immutable.fromJS(schedule));
    }
    default:
      return state;
  }
}
